const LOG_LEVEL = process.env.VUE_APP_LOG_LEVEL

window.Sanitas = window.Sanitas || {}
window.Sanitas.DVP = window.Sanitas.DVP || {}

function setLogLevel (level) {
  window.Sanitas.DVP.log_level = level
}
setLogLevel(LOG_LEVEL)

function getLogLevel () {
  return window.Sanitas.DVP.log_level
}

export const LogHelper = {
  error (params) {
    LogHelper.log('error', params)
  },

  info (params) {
    LogHelper.log('info', params)
  },

  log (severity, params) {
    const log_level = getLogLevel()

    if (log_level === ''|| !log_level) return
    if (!log_level.includes(severity.toUpperCase())) return

    if (Array.isArray(params)) {
      console[severity](...params)
    } else {
      console[severity](params)
    }
  },

  warn (params) {
    LogHelper.log('warn', params)
  }
}
